/* tslint:disable */
/* eslint-disable */
/**
 * HCL Commerce Services - Account and Contract
 * These services provide APIs to manage accounts and contracts.  a contract is an agreement that represents the terms and conditions that apply to a transaction. An account is a relationship between the merchant and the financial institution that processes transactions for that merchant.
 *
 * The version of the OpenAPI document: 9.1.6
 * 
 * (C) Copyright HCL Technologies Limited 2021
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../../../../../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../../../../../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../../../../../base';
// @ts-ignore
import { SlotsResponse } from '../../../../../com/hcl/commerce/typescript/axios';
/**
 * GetTimeSlotsApi - axios parameter creator
 * @export
 */
export const GetTimeSlotsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get TimeSlots
         * @summary Get TimeSlots
         * @param {string} storeId The store identifier.
         * @param {string} storeCode 
         * @param {string} universe 
         * @param {string} type 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTimeSlots: async (storeId: string, storeCode: string, universe: string, type: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('getTimeSlots', 'storeId', storeId)
            // verify required parameter 'storeCode' is not null or undefined
            assertParamExists('getTimeSlots', 'storeCode', storeCode)
            // verify required parameter 'universe' is not null or undefined
            assertParamExists('getTimeSlots', 'universe', universe)
            // verify required parameter 'type' is not null or undefined
            assertParamExists('getTimeSlots', 'type', type)
            const localVarPath = `/store/{storeId}/reclaim/getAvailableSlots`
                .replace(`{${"storeId"}}`, String(storeId));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (storeCode !== undefined) {
                localVarQueryParameter['storeCode'] = storeCode;
            }

            if (universe !== undefined) {
                localVarQueryParameter['universe'] = universe;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GetTimeSlotsApi - functional programming interface
 * @export
 */
export const GetTimeSlotsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GetTimeSlotsApiAxiosParamCreator(configuration)
    return {
        /**
         * Get TimeSlots
         * @summary Get TimeSlots
         * @param {string} storeId The store identifier.
         * @param {string} storeCode 
         * @param {string} universe 
         * @param {string} type 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTimeSlots(storeId: string, storeCode: string, universe: string, type: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SlotsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTimeSlots(storeId, storeCode, universe, type, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * GetTimeSlotsApi - factory interface
 * @export
 */
export const GetTimeSlotsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GetTimeSlotsApiFp(configuration)
    return {
        /**
         * Get TimeSlots
         * @summary Get TimeSlots
         * @param {string} storeId The store identifier.
         * @param {string} storeCode 
         * @param {string} universe 
         * @param {string} type 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTimeSlots(storeId: string, storeCode: string, universe: string, type: string, options?: any): AxiosPromise<SlotsResponse> {
            return localVarFp.getTimeSlots(storeId, storeCode, universe, type, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * GetTimeSlotsApi - object-oriented interface
 * @export
 * @class GetTimeSlotsApi
 * @extends {BaseAPI}
 */
export class GetTimeSlotsApi extends BaseAPI {
    /**
     * Get TimeSlots
     * @summary Get TimeSlots
     * @param {string} storeId The store identifier.
     * @param {string} storeCode 
     * @param {string} universe 
     * @param {string} type 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GetTimeSlotsApi
     */
    public getTimeSlots(storeId: string, storeCode: string, universe: string, type: string, options?: any) {
        return GetTimeSlotsApiFp(this.configuration).getTimeSlots(storeId, storeCode, universe, type, options).then((request) => request(this.axios, this.basePath));
    }
}
